import React, { useState, useEffect, useLayoutEffect } from 'react';
import useSWR from 'swr';
import { getSWR } from 'utils/api';
import { useWindowSize } from 'react-use';
import { useCurrentMember } from 'members/hooks/index';
import SnoozeReminders from './SnoozeReminders';
import useMatch from 'app/hooks/match';
import EditReminders from './EditReminders';

const Snooze = () => {
    const [step, setStep] = useState(0);
    const { width } = useWindowSize();
    const currMember = useCurrentMember();
    const { params } = useMatch();

    const handleStepChange = (newStep) => setStep(newStep);

    useEffect(() => {
        if (currMember?.['has-username-password-identifier'])
            setStep(0);
    }, [currMember?.['has-username-password-identifier']]);

    function getUrl() {
        return `/v3/public/reminders/${params?.snoozeId}`;
    }

    const { data } = useSWR(getUrl(), getSWR);
    const child_journal_id = data?.data?.data?.attributes?.['remindable-id']
    useSWR(child_journal_id ? `v3/public/child_journals/${child_journal_id}` : null)

    const renderStep = () => {
        switch (step) {
            case 0:
                return (
                    <SnoozeReminders
                        secret={params?.snoozeId}
                        child_journal_id={child_journal_id}
                        onStepUp={() => {
                            // firePostMemberEvent('design')
                            handleStepChange(step + 1)
                        }}
                        isFromMobile={width < 600}
                        onStepDown={() => handleStepChange(step - 1)}
                    />
                );
            case 1:
                return (
                    <EditReminders
                        secret={params?.snoozeId}
                        child_journal_id={child_journal_id}
                        onStepDown={() => handleStepChange(step - 1)}
                        onStepUp={() => handleStepChange(step + 1)}
                        isFromMobile={width < 600}
                    />
                );

            default:
                return null;
        }
    };
    return renderStep();
};

export default Snooze;
